import React from 'react'

export default function Archive({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path
        fill="currentColor"
        d="M44 26l-4-4-7 7-7-7-4 4 7 7-7 7 4 4 7-7 7 7 4-4-7-7 7-7z"
      ></path>
    </svg>
  )
}
